/**
 * `/login/verify` — one `RouteObject`, so the file is `verify.route.tsx`.
 *
 * A CHILD PATH of `/login` in the URL and a sibling entry in the table: the
 * auth half-shell is the layout both sit under, and nesting the code screen
 * inside a `/login` layout route would give the identity screen a shell it
 * does not own.
 *
 * No `loader`. The number it needs arrives in `location.state`, which is not a
 * data read, and the screen's own reads are `useQuery` calls in the component.
 */
import type { RouteObject } from 'react-router-dom';

export const verifyRoute: RouteObject = {
  path: '/login/verify',
  lazy: async () => {
    const { VerifyPage } = await import('./VerifyPage');
    return { Component: VerifyPage };
  },
};
